import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import Bluecoins from '../../components/Bluecoins/List';
import { PERMISSION_BLUECOINS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/bluecoins')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_BLUECOINS, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'table_list.tabs.bluecoin.list',
        suffix: 'menu.bluecoins',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: BluecoinsLayoutRoute,
});

function BluecoinsLayoutRoute() {
  const location = useLocation();
  // Only show the list when NOT on the usage route
  const showList = !location.pathname.includes('/bluecoins/usage');

  return (
    <>
      {/* Render the list only when not on usage route */}
      {showList && <Bluecoins />}
      {/* Outlet will render child routes (usage page, detail modal, etc.) */}
      <Outlet />
    </>
  );
}
